<div class="container-info-pay">
    <div class="logo-city">
        <img fallimg src="assets/img/citylok_logo.png" alt="Citylok logo">
    </div>
    <p class="title-confirm">Recibe tus entradas:</p>
    <div class="radio-select-method">
        <!-- <mat-radio-group [disabled]="waiting" [(ngModel)]="selected" class="d-grid" (ngModelChange)="changeMethod()">
            <mat-radio-button class="w-100 check-card-button section card-option" value="phone">
                <span class="title-section m-0">Teléfono</span>
            </mat-radio-button>
            <mat-radio-button class="w-100 check-card-button section card-option" value="mail">
                <span class="title-section m-0">Correo electrónico</span>
            </mat-radio-button>
        </mat-radio-group> -->
        <div class="group-input-method">
            <p class="info-text m-0">Introduce tu {{selected == 'phone' ? 'teléfono' : 'correo electrónico'}}:</p>
            <div class="bloque-input d-flex" *ngIf="selected=='phone'">
                <div class="input-custom w-100">
                    <input placeholder="Teléfono" id="input-movil" class="w-100" type="text" readonly [(ngModel)]="methodUser">
                </div>                    
                <button class="btn-clear" (click)="clearNumber()" *ngIf="methodUser"><i class="fa-light fa-times fa-lg"></i></button>
            </div>
            <div *ngIf="selected=='phone'">
                <div class="container-numbers d-grid">
                    <button class="btn-number" (click)="addNumber('1')">1</button>
                    <button class="btn-number" (click)="addNumber('2')">2</button>
                    <button class="btn-number" (click)="addNumber('3')">3</button>
                    <button class="btn-number" (click)="addNumber('4')">4</button>
                    <button class="btn-number" (click)="addNumber('5')">5</button>
                    <button class="btn-number" (click)="addNumber('6')">6</button>
                    <button class="btn-number" (click)="addNumber('7')">7</button>
                    <button class="btn-number" (click)="addNumber('8')">8</button>
                    <button class="btn-number" (click)="addNumber('9')">9</button>
                    <span></span>
                    <button class="btn-number" (click)="addNumber('0')">0</button>
                    <button class="btn-number btn-delete" (click)="deleteNumber()"><i class="fa-light fa-delete-left"></i></button>
            </div>
            <!-- <div class="bloque-input d-flex" *ngIf="selected=='mail'">
                    <div class="input-custom w-100">
                        <input placeholder="Correo electrónico" class="w-100" type="email" [(ngModel)]="methodUser">
                    </div>
                </div>
            </div> -->
        </div>

        <button class="btn-next-step pointer-in" [class.disabled]="!methodUser || methodUser.length < 9 || waiting" [disabled]="!methodUser"
            (click)="nextStep()">Siguiente</button>
    </div>